import moment from 'moment';

import createModel, { prop } from './lib/create_model';

const CommentPanel = createModel({
  modelName: 'CommentPanel',
  properties: {
    selectedItemId: prop(String).default(null),

    selectedComment: prop({
      id: prop(String).isRequired,
      at: prop(String).isRequired,
    }),
  },

  selectItemId(itemId) {
    this.selectedItemId = itemId;
  },

  clearItemId() {
    this.selectedItemId = null;
  },

  setSelectedCommentId(commentId) {
    if (commentId) {
      this.selectedComment = {
        id: commentId,
        at: moment().toISOString(),
      };
    } else {
      this.selectedComment = null;
    }
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});

export default CommentPanel;
